import { FileFolderTypeEnum } from "@/enums";

export class CreateFileFolderModel {
  /**ID проекта */
  ProjectId!: number;
  /**Тип папки */
  Type!: FileFolderTypeEnum;
  
  constructor(obj?: Partial<CreateFileFolderModel>) {
    Object.assign(this, obj);
  }
}